/**
 * Anecdotes API
 * Anecdotes API's
 *
 * OpenAPI spec version: 0.0.3
 * Contact: apiteam@anecdotes.ai
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ApprovalSettings } from './approvalSettings';
import { CycleStatus } from './cycleStatus';

export interface Policy {
  /**
   * The policy unique ID
   */
  policy_id?: string;
  /**
   * The policy name
   */
  policy_name?: string;
  /**
   * The policy description
   */
  policy_description?: string;
  /**
   * Has template url
   */
  policy_has_template?: boolean;
  /**
   * policy group
   */
  policy_group?: string;
  /**
   * The user who last added/edited this policy
   */
  policy_edited_by?: string;
  /**
   * The time this policy was last added/edited
   */
  policy_last_edit_time?: string;
  /**
   * Whether this policy was created or edit by the user
   */
  policy_is_custom?: boolean;
  /**
   * The related evidence
   */
  policy_related_evidence?: string;
  /**
   * Boolean to determine whether a note exists for this policy
   */
  note_exists?: boolean;
  policy_settings?: ApprovalSettings;
  notify_me_scheduledtask_id?: string;
  notify_approvers_scheduledtask_id?: string;
  snapshot_id?: string;
  policy_type?: string;
  policy_recommended_frameworks?: string[];
  global_policy_id?: string | null;
  policy_owner?: string;
  policy_status?: CycleStatus;
  is_just_approved?: boolean;
  shouldBePlacedFirst?: boolean;
  version_changes?: string;
  policy_ai?: {
    enabled: boolean;
    evidence_count: number;
    control_count: number;
    flow_id: string;
    status: PolicyAIFlowStatus;
  };
}

export function isPolicy(object: any): object is Policy {
  return object && 'policy_id' in object;
}

export type PolicyAIFlowStatus = 'success' | 'failure' | 'running';
export const PolicyAIFlowStatus = {
  Success: 'success' as PolicyAIFlowStatus,
  Failure: 'failure' as PolicyAIFlowStatus,
  Running: 'running' as PolicyAIFlowStatus,
};
